import { Memory } from "../../../api/generated";
import { incrementMemoryLikedCount } from "../../../api/memory";
import { useAppState, useSetAppState } from "../../../stores/appContext";
import { useAuth } from "../../auth/hooks/useAuth";

export const useIncrementLikedCount = (memories: Memory[]) => {
    const setAppState = useSetAppState();
    const state = useAppState();
    const { tempLikedMemoryIds } = state;
    const { csrfToken } = useAuth();

    const incrementLikedCount = (memoryId: string) => {
        if (!memories) return;
        if (tempLikedMemoryIds.includes(memoryId)) return;

        memories.map((memory) => {
            if (memory.id === memoryId) ++memory.likedCount;
            return memory;
        });

        setAppState((state) => ({
            ...state,
            tempLikedMemoryIds: [...state.tempLikedMemoryIds, memoryId],
        }));

        incrementMemoryLikedCount(memoryId, csrfToken).catch(() => {
            if (!memories) return;

            // 異常終了の場合、イイねインクリメント処理実行前の状態に戻す。
            memories.map((memory) => {
                if (memory.id === memoryId) --memory.likedCount;
                return memory;
            });
            setAppState((prevState) => {
                const newTempLikedMemoryIds =
                    prevState.tempLikedMemoryIds.filter((n) => n !== memoryId);
                return {
                    ...prevState,
                    tempLikedMemoryIds: [...newTempLikedMemoryIds],
                };
            });
        });
    };

    return { incrementLikedCount, tempLikedMemoryIds };
};
